import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CP_LEGEND_ITEMS,
  QC_LEGEND_ITEMS,
  PUNCHLIST_LEGEND_ITEMS,
  LOCK_LEGEND_ITEMS,
  SVG_MENU_ITEMS
} from '../constent/legendConstants';

const Legend = ({ layoutType }) => {
  let resolvedItems = [];

  switch (layoutType) {
    case 'CP':
      resolvedItems = CP_LEGEND_ITEMS;
      break;
    case 'QC':
      resolvedItems = QC_LEGEND_ITEMS;
      break;
    case 'Punchlist':
      resolvedItems = PUNCHLIST_LEGEND_ITEMS;
      break;
    case 'lock':
      resolvedItems = LOCK_LEGEND_ITEMS;
      break;
    case 'SVG':
      resolvedItems = SVG_MENU_ITEMS;
      break;
    default:
      console.warn(`Unknown layoutType: ${layoutType}`);
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 3,
        p: 1
      }}
    >
      {resolvedItems.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mr: 2
          }}
        >
          <Box
            sx={{
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              border: '1px solid #e0e0e0',
              backgroundColor: item.color
            }}
          />
          <Typography fontSize={16} fontWeight={600} color="#878787">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Legend;
